import { useEffect, useState } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import get from 'lodash/get';

import { Spinner } from '../../components/ui';
import useAssistantCommand from '../../common/use-assistant-command';

function AssistantCommandRunner({ match }: RouteComponentProps) {
  const integrationId: string | undefined = get(match.params, 'integrationId');
  const command: string | undefined = get(match.params, 'command');

  const { buildCommandAction, fetchCommandAction } = useAssistantCommand();

  const [isFetching, setIsFetching] = useState(true);
  const [cmd, setCmd] = useState<unknown>();

  useEffect(() => {
    if (!integrationId || !command) return;

    fetchCommandAction(integrationId, command)
      .then((action) => {
        // Check if action is valid (has data and type)
        // Canvas commands return {} from /command/ endpoint
        const isValidAction =
          action &&
          action.type &&
          (action.type === 'navigation' || action.type === 'request');

        if (isValidAction) {
          console.log('Fetched valid command action:', action);
          // Valid action metadata returned - use it (chat/native commands)
          setCmd({
            button_text: command,
            action: action,
          });
        } else {
          console.warn('Fetched invalid command action:', action);
          // Empty or invalid response - fall back to canvas/details view
          setCmd(buildCommandAction(integrationId, command));
        }
      })
      .catch((err) => {
        console.error(err);

        // Error fetching - fall back to canvas/details view
        setCmd(buildCommandAction(integrationId, command));
      })
      .finally(() => setIsFetching(false));
  }, [buildCommandAction, command, fetchCommandAction, integrationId]);

  return isFetching ? (
    <Spinner center={true} />
  ) : (
    <Redirect
      to={{ pathname: '/assistant/commands', state: { command: cmd } }}
    />
  );
}

export default AssistantCommandRunner;
